import { Box } from "@mui/material";
import { FlexBox, FooterButton, FullWidth, Section } from "./DualMenu.style";
import { useBreak } from "hooks/useBreak";
import { useLocation, useNavigate } from "react-router-dom";
import { get, getFocus, useAtom, useGet, useSet } from "state/jotai";
import { _bootstrap } from "state/store.bootstrap";
import { Icon } from "assets/Icons_";
import { SelectFunction } from "components/SelectFunction/SelectFunction";
import { ShiftProperty } from "components/ShiftProperty/ShiftProperty";
import { Controls } from "components/Isometry/Isometry.Controls";
import { getIsoData, getLowIsoData, setIsoData } from "state/jotai.isometryDataHooks";
import { Status } from "components/StatusPopup/StatusPopup";
import { useTranslation } from "react-i18next";
import { currentActiveProject, iconRotate, iso_free, iso_isrotating, mobileShiftSeasonMenu, seasonMode, turn_building, weaterMode } from "state/store.global";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { ArrowButton } from "components/Isometry/Isometry.Controls.Arrows";
import EusButton, { ETStyledButton } from "components/Button/EusButton";
import { AnimatePresence } from "framer-motion";
import { SelectWeatherMobile } from "components/SunDiagram/SeletWeatherMobile";
import { _project } from "state/store.projects";
import styled from "styled-components";
import { useIsIOS } from "hooks/useIsIos";

export const IsometryDualMenu = ({
  isometryToggle,
  left,
  right,
  nav,
  pin,
  pid,
  openSelectFunction,
  showSelectFunction,
  setShowSelectFunction,
  clickList,
  list,
  buttonsLabel,
  showProperty,
  setShowProperty,
  toggleDrawer,
  config,
  rotatemode,
  click2,
  turnBuilding,
  isrotate,
  click1,
  clickModel,
  model,
  filterShouldShow,
  clickFilter,
  filter,
  state,
  setState,
  closeDrawer,
  setShowFilter,
  setShowMenu,
  showOldSlider,
  atModel
}) => {
  const type     = getFocus(_bootstrap, "type");
  const navigate = useNavigate();
  const names    = getFocus(_bootstrap, "projectnames");
  const raw      = get(_project, 'unitsraw', 'Units')

  const [isSeasonModeOn, setSeasonMode]   = useAtom(seasonMode);
  const [shiftSeasonMenu, setShiftSeasonMenu] = useAtom(mobileShiftSeasonMenu);
  const [iconRotated, setIconRotated]   = useAtom(iconRotate)
  const setIsrotate = useSet(iso_isrotating)
  const setRmode = useSet(iso_free)
  
  
  const {
    i18n: { language },
  } = useTranslation();
  const isStatus   = true;
  const isMobile   = useBreak("md_dn");
  const here       = useLocation().pathname;
  const isIsometry = here.includes("isometry");

  const frame            = getIsoData("activeframe");
  const frames           = getIsoData("frames");
  const index            = getIsoData("snapindex");
  const setIndex         = setIsoData("snapindex");
  const setFrame         = setIsoData("activeframe");
  const percent          = getIsoData("percent");
  const setActiveProject = useAtom(currentActiveProject)[1];

  const setWeatherMode = useSet(weaterMode);
  const [, setIsTurnBuilding] = useAtom(turn_building);
  const ios = useIsIOS();


  const showButton = [
    "list",
    "compare",
    "favorites",
    "gallery",
    "downloads",
  ].some((i) => here.includes(i));

  const props = { type, isIsometry, pin, isMobile, pid };
  return (
    <>
      <FullWidth
        isMobile = {isMobile}
        left     = {left}
        right    = {right}
        nav      = {nav}
        clr      = {clr}
        isBgTrue = {true}
      >
        <FlexBox clr = {clr} isIsometry = {isIsometry}>
          {isMobile ? (
            <>
            { shiftSeasonMenu &&
                <AnimatePresence exitBeforeEnter>
                    { isMobile && atModel && isSeasonModeOn && <SelectWeatherMobile />}
                 </AnimatePresence>
            }
              {
                isSeasonModeOn && atModel ?
                <>
                  <EusButton
                  width = {"185px"}
                   {...props}
                   clr          = {clr}
                   onClick      = {rotatemode && isrotate ? click1 : click2}
                   variant      = {"primary"}
                   icon         = {true}
                   iconName     = {isrotate ? "pause" : "play"}
                   isFaIcon     = {true}
                   buttonlabel  = {false}
                   otherText    = {isrotate ? "Stop" : "Start"}
                   fontAswStyle = {{fontSize:'24px'}}
                 />
                </>
                : 
                <>
                  {!rotatemode && !showOldSlider && isIsometry && (
                    <Box sx = {{ marginRight: '8px' }}>
                      <ArrowButton
                        variant = {"primary"}
                        clr     = {clr}
                        onBlur  = {()=> setShowSelectFunction(false)}
                        onClick = {()=> {
                            // if(showSelectFunction) {
                            //     setShowSelectFunction(false)
                            //     } else openSelectFunction()
                            // openSelectFunction()
                          setShowSelectFunction(!showSelectFunction)
                          }
                      }
                        padding = "18px"
                      >
                       <span
                          style={{
                            fontSize: "22px",          // This will enlarge the icon
                            display : "inline-flex",   // Ensures proper alignment
                          }}
                        >
                          <Icon
                            icon     = "ellipsisvertical"
                            color    = {clr.primary}
                            isFaIcon = {true}
                            size     = "md"
                            wrap     = {{ transform: showSelectFunction ? 'rotate(90deg)' : 'rotate(0deg)'}}
                          />
                        </span>

                       
                      </ArrowButton>
                      <SelectFunction
                          clickModel={clickModel}
                           click1                = {click1}
                           click2                = {click2}
                           isrotate              = {isrotate}
                           turnBuilding          = {turnBuilding}
                           rotatemode            = {rotatemode}
                           showSelectFunction    = {showSelectFunction}
                           setShowSelectFunction = {setShowSelectFunction}
                        />
                    </Box>
                )}
              {type === "poly" && rotatemode ? (
                   <EusButton
                   {...props}
                   clr         = {clr}
                   onClick     = {rotatemode && isrotate ? click1 : click2}
                   variant     = {"primary"}
                   icon        = {true}
                   iconName    = {isrotate ? "pause" : "play"}
                   isFaIcon    = {true}
                   buttonlabel = {false}
                   otherText   = {isrotate ? "Stop" : "Start"}
                   iconSize    = {"xl"}
                 />
              ) : type === "mono" && turnBuilding ? (
                <Section
                  padding = "0 30px"
                  {...props}
                  clr     = {clr}
                  onClick = {rotatemode && isrotate ? click1 : click2}
                >
                  <Icon
                    icon     = {isrotate ? "pause" : "play"}
                    color    = {clr?.primary_text}
                    isFaIcon = {true}
                    size     = "lg"
                  />{" "}
                  <p style = {{ color: clr?.primary_text }}>
                    {isrotate ? "Stop" : "Start"}
                  </p>
                </Section>
              ) : (
                <>
                  <Box
                    sx={{
                      display       : "flex",
                      justifyContent: isIsometry
                        ? "flex-start"
                                :    "space-between",
                      gap       : "8px",
                      position  : "relative",
                      alignItems: "center",
                      width     : "100%",
                    }}
                  >

                   
                    {isIsometry ? (
                      <EusButton
                        {...props}
                        clr         = {clr}
                        active      = {here.includes("list")}
                        onClick     = {clickList}
                        variant     = {"primary"}
                        iconName    = {"list"}
                        icon        = {true}
                        buttonText  = "Boligliste"
                        buttonlabel = {true}
                        iconSize    = {"xl"}
                        isFaIcon    = {true}
                      />
                    ) : type === "poly" && pin === 0 ? (
                      <EusButton
                        iconName    = {"modelover"}
                        icon        = {true}
                        clr         = {clr}
                        buttonlabel = {false}
                        otherText   = {buttonsLabel?.filter(
                                  (btn) => btn.UILabelProperty === "Oversigtskort"
                                )[0]?.Label}
                        onClick     = {clickModel}
                        variant     = {"primary"}
                        pin         = {pin}
                        iconSize    = {"xl"}
                        showButton  = {showButton}
                        isFaIcon    = {true}
                        active      = {true}
                      />
                    ) : (
                      <EusButton
                        pin         = {pin}
                        clr         = {clr}
                        showButton  = {showButton}
                        active      = {true}
                        onClick     = {clickModel}
                        variant     = {"primary"}
                        iconName    = {"model"}
                        icon        = {true}
                        buttonText  = "isometri"
                        buttonlabel = {true}
                        iconSize    = {"25"}
                        isFaIcon    = {false}
                      />
                    )}
                  </Box>
                    
                  {isIsometry && (
                    <Box>
                        {!rotatemode && percent == 100 && (
                          <>
                            {config?.IMAGE_SNAPFRAMES?.length > 1 && (
                              <Controls
                                {...{
                                  isometryToggle,
                                  frame,
                                  setFrame,
                                  config: config,
                                  frames,
                                  index,
                                  setIndex,
                                }}
                              />
                            )}
                          </>
                        )}
                    </Box>
                  )}
                </>
              )}
                </>
              }
            </>
          ) : (
            <>
              <Box
                sx={{
                           width                           : isMobile && !isIsometry ? "100%": "100%",
                           display                         : "flex",
                           justifyContent                  : 
                  isMobile && !isIsometry ? "space-between": "flex-start",
                           gap                             : "16px",
                           position                        : "relative",
                }}
              >
                { !turnBuilding && pin > 0 &&
                 !showOldSlider &&
                    <ArrowButton
                        variant = {"primary"}
                        clr     = {clr}
                        padding = "18px"
                        onBlur  = {()=> setShowSelectFunction(false)}
                        onClick = {()=> {
                                // if(showSelectFunction) {
                                //     setShowSelectFunction(false)
                                //     } else openSelectFunction()
                          openSelectFunction()
                          }
                      }
                      >
                       <span
                          style={{
                            fontSize: "22px",          // This will enlarge the icon
                            display : "inline-flex",   // Ensures proper alignment
                          }}
                        >
                          <Icon
                            icon     = "ellipsisvertical"
                            color    = {clr.primary}
                            isFaIcon = {true}
                            size     = "md"
                            wrap     = {{ transform: showSelectFunction ? 'rotate(90deg)' : 'rotate(0deg)'}}
                          />
                        </span>

                        <SelectFunction
                          clickModel={clickModel}
                            click1                = {click1}
                            click2                = {click2}
                            isrotate              = {isrotate}
                            turnBuilding          = {turnBuilding}
                            rotatemode            = {rotatemode}
                            showSelectFunction    = {showSelectFunction}
                            setShowSelectFunction = {setShowSelectFunction}
                        />
                    </ArrowButton>
                }
                {turnBuilding ? (
                  <>
                  <EusButton
                   {...props}
                   clr         = {clr}
                   onClick     = {rotatemode && isrotate ? click1 : click2}
                   variant     = {"primary"}
                   icon        = {true}
                   iconName    = {isrotate ? "pause" : "play"}
                   isFaIcon    = {true}
                   buttonlabel = {false}
                   otherText   = {isrotate ? "Stop" : "Start"}
                   iconSize    = {"xl"}
                 />
                  </>
                ) : (
                  <>
                    {isIsometry ? (
                      <EusButton
                        {...props}
                        clr         = {clr}
                        active      = {here.includes("list")}
                        onClick     = {clickList}
                        variant     = {"primary"}
                        iconName    = {"list"}
                        icon        = {true}
                        buttonText  = "Boligliste"
                        buttonlabel = {true}
                        iconSize    = {"xl"}
                        isFaIcon    = {true}
                      />
                    ) : type === "poly" && pin === 0 ? (
                      <EusButton
                        iconName    = {"modelover"}
                        icon        = {true}
                        clr         = {clr}
                        buttonlabel = {false}
                        otherText   = {buttonsLabel?.filter(
                                  (btn) => btn.UILabelProperty === "Oversigtskort"
                                )[0]?.Label}
                        onClick     = {clickModel}
                        variant     = {"primary"}
                        pin         = {pin}
                        iconSize    = {"xl"}
                        showButton  = {showButton}
                        isFaIcon    = {true}
                        active      = {true}
                      />
                    ) : (
                      <EusButton
                        pin         = {pin}
                        clr         = {clr}
                        showButton  = {showButton}
                        active      = {true}
                        onClick     = {clickModel}
                        variant     = {"primary"}
                        iconName    = {"model"}
                        icon        = {true}
                        buttonText  = "isometri"
                        buttonlabel = {true}
                        iconSize    = {"25"}
                        isFaIcon    = {false}
                      />
                    )}
                    {filterShouldShow && !isMobile && (
                            // <FooterButton
                            //   tabIndex={"0"}
                            //   role="button"
                            //   variant={"primary"}
                            //   pin={pin}
                            //   clr={clr}
                            //   showButton={showButton}
                            //   onClick={clickFilter}
                            // >
                            //   <Icon
                            //     color={clr.primary_text}
                            //     {...filter}
                            //     isFaIcon={true}
                            //   />
                            //   <div
                            //     className="eus-button-2"
                            //     style={{ color: clr?.primary_text }}
                            //   >
                            //     {
                            //       buttonsLabel?.filter(
                            //         (btn) => btn.UILabelProperty === "Anvendfilter"
                            //       )[0]?.Label
                            //     }
                            //   </div>
                            // </FooterButton>
                      <EusButton
                        iconName    = {"filters"}
                        icon        = {true}
                        clr         = {clr}
                        buttonText  = "Anvendfilter"
                        buttonlabel = {true}
                        onClick     = {clickFilter}
                        variant     = {"primary"}
                        pin         = {pin}
                        showButton  = {showButton}
                        iconSize    = {"xl"}
                        isFaIcon    = {true}
                      />
                    )}
                    {/* UnComment this whenever we have all property on else comment ShiftProperty component section */}
                    {type === "poly" && pin > 0 && (
                      <EusButton
                        iconName    = {"modelover"}
                        icon        = {true}
                        clr         = {clr}
                        buttonlabel = {false}
                        otherText   = {buttonsLabel?.filter(
                                  (btn) => btn.UILabelProperty === "Oversigtskort"
                                )[0]?.Label}
                        onClick     = {() => {
                          closeDrawer("detail");
                          setShowFilter(false);
                          setShowMenu(false);
                          setActiveProject("");
                          navigate(
                            type == "mono"
                              ? `/${language}/isometry`
                              :    `/${language + names[language][0].path}`
                          );
                        }}
                        variant    = {"primary"}
                        pin        = {pin}
                        iconSize   = {"xl"}
                        showButton = {showButton}
                        isFaIcon   = {true}
                        active     = {true}
                      />
                    )}

                    {/* remove this pin when we have property more than 1 */}
                    {type === "poly" && (
                            // <EusButton
                            //   iconName={"buildings"}
                            //   icon={true}
                            //   clr={clr}
                            //   buttonlabel={false}
                            //   otherText={" Skift ejendom"}
                            //   onClick={() => {
                            //     setShowProperty(!showProperty);
                            //     toggleDrawer();
                            //   }}
                            //   variant={"primary"}
                            //   pin={pin}
                            //   iconSize={"xl"}
                            //   showButton={showButton}
                            //   isFaIcon={true}
                            //   active={true}
                            //   iconColor={
                            //     pin > 0 || showButton ? "#fff" : clr?.primary_text
                            //   }
                            // >
                            //   <ShiftProperty
                            //     showProperty={showProperty}
                            //     setShowProperty={setShowProperty}
                            //   />
                            // </EusButton>

                      <ETStyledButton
                        variant = {"primary"}
                        pin     = {pin}
                        onClick = {() => {
                          if (!showProperty) {
                            setShowProperty(true);
                            toggleDrawer();
                          } else {
                            setShowProperty(false);
                            toggleDrawer();
                            const buttons = document.querySelectorAll("button");
                            buttons.forEach((button) => button.blur());
                          }
                                // setShowProperty(!showProperty);
                                // toggleDrawer();
                        }}
                        clr        = {clr}
                        showButton = {showButton}
                      >
                        <Icon
                          icon  = "buildings"
                          size  = "lg"
                          color = {
                            pin > 0 || showButton ? "#fff":"#fff"
                          }
                          isFaIcon = {true}
                        />
                        <div
                          className = "eus-button-2"
                          style     = {{ color: clr?.primary }}
                        >
                           {
                              buttonsLabel?.filter(
                                  (btn) => btn.UILabelProperty === "shiftProperty"
                                )[0]?.Label
                            }
                        </div>
                        <ShiftProperty
                          showProperty    = {showProperty}
                          setShowProperty = {setShowProperty}
                        />
                      </ETStyledButton>
                     
                    )}

                    {type === "poly" && pin !== 0 && Boolean(raw.length) &&  (
                      <ETStyledButton
                        variant      = {isMobile ? "secondary" : "primary"}
                        isStatus     = {isStatus}
                        pin          = {pin}
                        clr          = {clr}
                        onClick      = {() => isMobile && setState(!state)}
                        onMouseEnter = {() => !isMobile && setState(true)}
                        onMouseLeave = {() => !isMobile && setState(false)}
                      >
                        <Status
                          pin      = {pin}
                          state    = {state}
                          setState = {setState}
                          isMobile = {isMobile}
                          {...{ percent: percent }}
                        />
                      </ETStyledButton>
                    )}
                    {type === "mono" && isIsometry && Boolean(raw.length) && (
                      <ETStyledButton
                        variant      = {isMobile ? "secondary" : "primary"}
                        isStatus     = {isStatus}
                        pin          = {pin}
                        clr          = {clr}
                        onClick      = {() => setState(!state)}
                        onMouseEnter = {() => !isMobile && setState(true)}
                        onMouseLeave = {() => !isMobile && setState(false)}
                      >
                        <Status
                          pin      = {pin}
                          state    = {state}
                          setState = {setState}
                          isMobile = {isMobile}
                          {...{ percent: percent }}
                        />
                      </ETStyledButton>
                    )}
                     { 
                    //  atModel &&
                      // <ETStyledButton
                      //   variant  = {"primary"}
                      //   isMobile = {isMobile}
                      //   pin      = {pin}
                      //   clr      = {clr}
                      //   onClick  = {()=> {
                      //       // Toggle the weather mode state
                      //       setSeasonMode(!iconRotated)
                      //       // Toggle icon rotation
                      //       setIconRotated(!iconRotated)
                      //       setWeatherMode(!iconRotated)
                      //       setIsTurnBuilding(!iconRotated)
                      //     if(!iconRotated) {
                      //       setIsrotate(true)
                      //       setRmode(true)
                      //     }else {
                      //       setRmode(false)
                      //       setIsrotate(false)
                      //     }
                      //   }}
                      // >
                      //     <RotatingIcon icon      = 'sun' size = {'24'} color = {'#fff'} rotated = {iconRotated} />
                      //     <div          className = "eus-button-2">{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'Soldiagram')[0]?.Label || "Sun Diagram"}</div>
                      // </ETStyledButton>
                    }
                  </>
                )}
              </Box>
              {!turnBuilding && isIsometry && (
                <Box>
                    {!rotatemode && percent == 100 && (
                      <>
                        {config?.IMAGE_SNAPFRAMES?.length > 1 && (
                          <Controls
                            {...{
                              isometryToggle,
                              frame,
                              setFrame,
                              config: config,
                              frames,
                              index,
                              setIndex,
                            }}
                          />
                        )}
                      </>
                    )}
                </Box>
              )}
            </>
          )}
        </FlexBox>
        
        <PoweredBy clr ="#004337"
          padding={isMobile ? ios ? "0px 0 calc(env(safe-area-inset-bottom, 0px) + 8px) 0" : "0px 0 24px 0" : "0px 0 8px 0"}
        //  padding = { isMobile ? ios ? "0px 0 50px 0" : "0px 0 24px 0" : "0px 0 8px 0"}
          />
      </FullWidth>
    </>
  );
};


const RotatingIcon = styled(Icon)`
  transition: transform 0.3s ease-in-out;

  ${(props) => props.rotated && `
    transform: rotate(90deg);
  `}
`;